import { BaseShaderMaterial, ResourceContainer, Screen, Time, Configuration } from '../engine';
import fragment from '../shaders/GlassFrontShader.frag';
import vertex from '../shaders/GlassFrontShader.vert';
import DatGui from '../components/DatGui';

import { Vector2 } from 'three';
import { Color } from 'three';
import { FrontSide } from 'three';



export default class GlassFrontMaterial extends BaseShaderMaterial
{
  constructor(rt)
  {
    super(vertex, fragment, {
      resolution: { value :
        new Vector2(Screen.width, Screen.height).multiplyScalar(
          window.devicePixelRatio
        )}
      ,
      backNormals: {value : rt.texture},
      envMap: {value : ResourceContainer.get_resource('cube')},
      color: {value: new Color(0xe0e0e0)},
      refractionIndex: {value: DatGui.settings.refractionIndex},
      dispersion: {value: DatGui.settings.dispersion},
      opacity: {value: DatGui.settings.opacity},
      roughness: {value: DatGui.settings.roughness},
      fesnel: {value: DatGui.settings.fesnel},
      noise: {value: ResourceContainer.get_resource('noise')},
      timer: {value: 0},
    });
    this.original_opacity = DatGui.settings.opacity;
    this.side = FrontSide;
    this.alphaTest = 0.0;
    this.transparent = true;
    this.needsUpdate = true;  
  }

  set opacity(value) 
  {
    if (this.uniforms)
      this.uniforms.opacity.value = value * this.original_opacity;
  }

  get opacity() 
  {

  }
  
  update()
  {
    // Use Configuration.dpr (capped at 2) to match actual renderer pixel ratio
    const dpr = Configuration.dpr || window.devicePixelRatio;
    this.uniforms.resolution.value.set(Screen.width * dpr, Screen.height * dpr);
  }
   
  //set(white) {
  //  if (white) {
  //    this.uniforms.color.value.setHex(0xe0e0e0)
  //  } else {
  //    this.uniforms.color.value.setHex(0xa0e0a0)
  //  }
  //}
}
